import { useState, useEffect } from 'react'
import { Autocomplete, Button, Drawer, Grid, TextField } from '@mui/material'
import { AddIcon } from 'components/Icons'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { BasePathProvider } from 'components/Providers'
import { getCampus, getTypes } from 'store/lookup'
import { search as ServiceList } from 'store/settings/service-access'
import List from './List/List'
import FormIndex from './Form'

const basePath = '/settings/school-access'

export default function SchoolAccessPage() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { id } = useParams()
  const [search, setSearch] = useState('')
  const [typeFilter, setTypeFilter] = useState('school')

  const campusList = useSelector(state => state.lookup.campus)
  const list = useSelector(state => state.settings.serviceAccess.list)
  const districtTypes = useSelector(state =>
    state.lookup.types?.filter(tp => tp.category === 'districtType' && tp.code !== 'provider') ?? []
  )

  useEffect(() => { if (!campusList) dispatch(getCampus()) }, [campusList])
  useEffect(() => { if (!districtTypes.length) dispatch(getTypes()) }, [])

  const filteredList = (list ?? [])
    .filter(row => {
      const name = `${row.firstName ?? ''} ${row.lastName ?? ''}`.toLowerCase()
      const matchesSearch = !search || name.includes(search.toLowerCase())
      const matchesType = !typeFilter || row.personServiceRoles?.some(r => r.type === typeFilter)
      return matchesSearch && matchesType
    })
    .map(row => ({
      ...row,
      personServiceRoles: typeFilter
        ? row.personServiceRoles?.filter(r => r.type === typeFilter)
        : row.personServiceRoles,
    }))

  useEffect(() => {
    if (!list) dispatch(ServiceList())
  }, [list])

  const selectedTypeObj = districtTypes.find(tp => tp.code === typeFilter) ?? null

  return (
    <BasePathProvider value={basePath}>
      <Grid container spacing={2} sx={{ my: 2 }}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size='small'
            label={t('Search')}
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Autocomplete
            size='small'
            options={districtTypes}
            getOptionLabel={option => option.name ?? ''}
            value={selectedTypeObj}
            onChange={(_, value) => { if (value) setTypeFilter(value.code) }}
            disableClearable
            renderInput={params => <TextField {...params} label={t('Type')} fullWidth />}
          />
        </Grid>
        <Grid item xs={12} md={2} sx={{ display: 'flex', alignItems: 'center' }}>
          <Button fullWidth variant='contained' color='primary' startIcon={<AddIcon />} onClick={() => navigate(`${basePath}/new`)}>
            {t('Add Access')}
          </Button>
        </Grid>
      </Grid>
      <List list={filteredList} loading={list === null} />
      <Drawer
        PaperProps={{ sx: { width: 600 } }}
        open={Boolean(id)}
        anchor='right'
        onClose={() => navigate(basePath)}
      >
        <FormIndex type={typeFilter} />
      </Drawer>
    </BasePathProvider>
  )
}
